import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import CloseIcon from '../../assets/icons/JSX/CloseIcon'
import Logo from '../../assets/icons/JSX/Logo'
import LogoGe from '../../assets/icons/JSX/LogoGe'
import MenuIcon from '../../assets/icons/JSX/MenuIcon'
import Colors from '../../assets/styles/Colors'
import { LargeContainer, ScrollbarInMobile } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import { useAppSelector } from '../../store'
import { NavLink } from 'react-router-dom'

import MobileMenuBackground from '../../assets/icons/mobile-menu-background-image.svg'
import LangDropdown from '../../components/LangDropdown'
import { UserRole } from '../../domain/types'
import { AppState } from '../../store/appSlice'

const Header = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState<boolean>(false)
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  const auth = useAppSelector((data) => data.auth)
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [logout, { isLoading: logOutLoading }] = api.useLogoutMutation()

  const Logout = async () => {
    try {
      await logout({}).unwrap()
      navigate(`/login`)
    } catch (error: any) {
      toast('logout error | ' + error)
    }
  }
  const [scrollCount, setScrollCount] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY
      setScrollCount(currentScroll)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  // test comment
  return logOutLoading ? (
    <Loader />
  ) : (
    <HeaderStyle $scrollCount={scrollCount}>
      <ScrollbarInMobile hideScroll={openMobileMenu} />
      <LargeContainer>
        <Content>
          <Wrapper $openMobileMenu={openMobileMenu}>
            <LeftSide>
              <LogoWrapper>
                {lang === 'ge' ? (
                  <LogoGeStyle onClick={() => [navigate('/'), setOpenMobileMenu(!openMobileMenu)]} />
                ) : lang === 'en' ? (
                  <LogoStyle onClick={() => [navigate('/'), setOpenMobileMenu(!openMobileMenu)]} />
                ) : (
                  <LogoStyle onClick={() => [navigate('/'), setOpenMobileMenu(!openMobileMenu)]} />
                )}
                <MobileCloseBtnDiv>
                  <CloseIconStle onClick={() => setOpenMobileMenu(!openMobileMenu)} />
                </MobileCloseBtnDiv>
              </LogoWrapper>
              <Ul>
                <Li>
                  <NavLinkStyle onClick={() => setOpenMobileMenu(!openMobileMenu)} to="/">
                    {t('retail')}
                  </NavLinkStyle>
                </Li>
                <Li>
                  <NavLinkStyle onClick={() => setOpenMobileMenu(!openMobileMenu)} to="/business">
                    {t('business')}
                  </NavLinkStyle>
                </Li>
                <Li>
                  <NavLinkStyle
                    style={{
                      background: Colors.secondaryRed,
                      padding: '5px 12px',
                      color: Colors.white,
                      borderRadius: '6px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                    }}
                    onClick={() => setOpenMobileMenu(!openMobileMenu)}
                    to="/ai-assistent"
                  >
                    {t('AI Beta')}
                  </NavLinkStyle>
                </Li>
              </Ul>
            </LeftSide>
            <RightSide>
              <LangDropdown />
              <VerticalLine />
              <AuthButtons>
                {auth.user && auth.token && auth.user.userType === UserRole['User'] ? (
                  <SignUpBtn onClick={() => [navigate('/my-policies'), setOpenMobileMenu(!openMobileMenu)]}>
                    <span>{t('profile')}</span>
                  </SignUpBtn>
                ) : (
                  <SignUpBtn onClick={() => [navigate('/auth/personal-info'), setOpenMobileMenu(!openMobileMenu)]}>
                    <span>{t('signUp')}</span>
                  </SignUpBtn>
                )}

                {auth.user && auth.token && auth.user.userType === UserRole['User'] ? (
                  <SignInBtn onClick={Logout}>
                    <span>{t('logOut')}</span>
                  </SignInBtn>
                ) : (
                  <SignInBtn onClick={() => [navigate('/login'), setOpenMobileMenu(!openMobileMenu)]}>
                    <span>{t('signIn')}</span>
                  </SignInBtn>
                )}
              </AuthButtons>
            </RightSide>
          </Wrapper>
          <MobileHead>
            {lang === 'ge' ? (
              <LogoGeStyleInMobile onClick={() => navigate('/')} />
            ) : lang === 'en' ? (
              <LogoStyleInMobile onClick={() => navigate('/')} />
            ) : (
              <LogoStyleInMobile onClick={() => navigate('/')} />
            )}
            <CloseIconBox onClick={() => setOpenMobileMenu(!openMobileMenu)}>
              <MenuIconStyle />
            </CloseIconBox>
          </MobileHead>
        </Content>
      </LargeContainer>
    </HeaderStyle>
  )
}

//
const Content = styled.div`
  width: 100%;
`
const AuthButtons = styled.div`
  ${Responsive.mobile} {
    margin-top: auto;
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`
const MenuIconStyle = styled(MenuIcon)`
  height: 14px;
`
const CloseIconBox = styled.div`
  padding: 10px;
  margin-right: -10px;
  cursor: pointer;
`
const MobileCloseBtnDiv = styled.div`
  ${Responsive.mobile} {
    padding: 10px;
    margin-top: -10px;
    margin-right: -10px;
  }
`
const CloseIconStle = styled(CloseIcon)`
  display: none;
  height: 13px;
  ${Responsive.mobile} {
    display: block;
  }
`
const LogoStyleInMobile = styled(Logo)`
  width: 60px;
  height: fit-content;
`
const LogoGeStyleInMobile = styled(LogoGe)`
  width: 60px;
  height: fit-content;
`
const MobileHead = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    width: 100%;
  }
`
const VerticalLine = styled.div`
  height: 20px;
  width: 1px;
  background-color: ${Colors.Mercury};
  margin-left: 15px;
  ${Responsive.mobile} {
    display: none;
  }
`
const SignUpBtn = styled.button`
  height: 40px;
  margin-inline: 15px 40px;
  padding: 0px 15px;
  outline: none;
  background-color: transparent;
  border: 0px;
  span {
    font-size: 14px;
    color: ${Colors.Black};
  }
  ${Responsive.tablet} {
    padding: 0px;
    margin-inline: 15px 30px;
  }
  ${Responsive.mobile} {
    width: 100%;
    margin: 0px;
  }
`
const SignInBtn = styled.button`
  width: 120px;
  height: 40px;
  margin: 0px;
  padding: 0px;
  outline: none;
  border: 1px solid ${Colors.Black};
  background-color: transparent;
  border-radius: 4px;
  span {
    font-size: 14px;
    color: ${Colors.Black};
  }
  &:hover {
    background-color: ${Colors.Black};
    span {
      color: ${Colors.white};
    }
  }

  ${Responsive.mobile} {
    width: 100%;
    height: 40px;
    margin-top: 30px;
    margin-left: 0px !important;
    background-color: ${Colors.white};
  }
`
const LogoStyle = styled(Logo)`
  width: 90px;
  margin-top: -10px;
  height: 41px;
  ${Responsive.tablet} {
    width: 70px;
    margin-top: -8px;
    height: 27px;
  }
  ${Responsive.mobile} {
    width: 60px;
    margin-top: -3px;
    height: 26px;
  }
`
const LogoGeStyle = styled(LogoGe)`
  width: 96px;
  margin-top: -10px;
  height: fit-content;
  ${Responsive.tablet} {
    width: 70px;
    margin-top: -8px;
  }
  ${Responsive.mobile} {
    width: 60px;
    margin-top: -3px;
    height: 26px;
  }
`
const Wrapper = styled.div<{ $openMobileMenu: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 200ms ease-in-out;
  ${Responsive.mobile} {
    position: fixed;
    top: 0;
    left: ${({ $openMobileMenu }) => ($openMobileMenu === true ? '0' : '-100vw')};
    transition: all 200ms ease-in-out;
    background-color: ${Colors.white};
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    justify-content: start;
    background-repeat: no-repeat;
    background-position: right -34px bottom 0px;
    background-image: url(${MobileMenuBackground});
    overflow-y: scroll;
  }
`
const Ul = styled.ul`
  display: flex;
  align-items: center;
  margin: 0px;
  padding-left: 0px;
  list-style: none;
  cursor: pointer;
  ${Responsive.mobile} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 40px;
    border-bottom: 1px solid ${Colors.Mercury};
    padding-bottom: 40px;
    margin-bottom: 30px;
  }
`
const Li = styled.li`
  margin-right: 57px;
  text-transform: capitalize;
  font-size: 18px;
  color: ${Colors.SilverChalice};
  transition: all 100ms ease-in-out;
  &:last-child {
    margin-right: 0px;
  }
  &:hover {
    color: ${Colors.Black};
    transition: all 100ms ease-in-out;
  }
  ${Responsive.tablet} {
    margin-right: 15px;
    font-size: 16px;
  }
  ${Responsive.mobile} {
    font-size: 14px;
    padding-top: 2px;
    padding-bottom: 2px;
    margin-bottom: 18px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`
const NavLinkStyle = styled(NavLink)`
  color: ${Colors.nevadaGrey};
  text-decoration: none;
  line-height: 18px;

  &:hover {
    color: ${Colors.primaryBlack};
  }
`
const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 80px;
  cursor: pointer;
  ${Responsive.tablet} {
    margin-right: 30px;
  }
  ${Responsive.mobile} {
    justify-content: space-between;
    margin-right: 0px;
  }
`
const RightSide = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Responsive.mobile} {
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 50px;
    margin-bottom: 50px;

    .language-dropdown-wrapper {
      margin-top: 30px;
    }
  }
`
const LeftSide = styled.div`
  display: flex;

  /* acive tab styles */
  a.active {
    border-bottom: 2px solid ${Colors.primaryBlack};
    color: ${Colors.primaryBlack};
    padding-bottom: 3px;
  }

  ${Responsive.mobile} {
    width: 100%;
    flex-direction: column;
    padding-top: 25px;
    padding-right: 25px;
    padding-left: 25px;

    /* acive tab styles */
    a.active {
      border-bottom: unset;
      padding-bottom: 0px;
    }
  }
`
const HeaderStyle = styled.header<{ $scrollCount: number }>`
  position: sticky;
  top: 0;
  transition: all 200ms ease-in-out;
  z-index: 15;
  padding-block: 28px;
  background-color: ${Colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${({ $scrollCount }) => ($scrollCount >= 10 ? '0px 1px 5px -4px rgba(0, 0, 0, 0.45)' : 'unset')};
  ${Responsive.mobile} {
    height: fit-content;
    padding-block: unset;
  }
`

export default Header
